import { Elm } from '/src/Main.elm'
var app = Elm.Main.init({ node: document.querySelector('main') })




import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";


// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyCXWET2Z5VkWAHJph80aNLnAjZoEeJKJ-4",
    authDomain: "elm-template.firebaseapp.com",
    databaseURL: "https://elm-template.firebaseio.com",
    projectId: "elm-template",
    storageBucket: "elm-template.appspot.com",
    messagingSenderId: "630474917921",
    appId: "1:630474917921:web:2e773066c0f1e11b5afb60",
    measurementId: "G-SGKP74NY2Q"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
const auth = firebase.auth();
const db = firebase.firestore();
firebase.auth().signInAnonymously()
    .then(() => {
        console.log("user created")
    })
    .catch((error) => {
        var errorCode = error.code;
        var errorMessage = error.message;
        // ...
    });

window.USER_IS_TOUCHING = false;
window.addEventListener('touchstart', function onFirstTouch() {

    window.USER_IS_TOUCHING = true;

    window.removeEventListener('touchstart', onFirstTouch, false);
}, false);

app.ports.logTime_.subscribe((data) => {
    if (data) {

        data.touch = USER_IS_TOUCHING;
        db.collection("reactionTimes").doc().set(data)
            .then(() => {
                console.log("added");
            })
            .catch(err => {
                console.log("error: ", err);

            });
    }
});